import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./PropertyPage.css";

export default function PropertyPage() {
  var params = useParams();
  var [property, setProperty] = useState(null);
  var [loading, setLoading] = useState(true);
  var [activeRoom, setActiveRoom] = useState(null);
  var [activePhotoIndex, setActivePhotoIndex] = useState(0);

  useEffect(function () {
    window.scrollTo(0, 0);
    fetch("/api/properties/" + params.slug)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        setProperty(data.property || data);
        setLoading(false);
      })
      .catch(function (err) {
        console.error("Failed to load property", err);
        setLoading(false);
      });
  }, [params.slug]);

  useEffect(function () {
    if (activeRoom) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return function () { document.body.style.overflow = ""; };
  }, [activeRoom]);

  function openRoom(room) {
    setActiveRoom(room);
    setActivePhotoIndex(0);
  }

  function closeRoom() {
    setActiveRoom(null);
    setActivePhotoIndex(0);
  }

  function prevPhoto(e) {
    e.stopPropagation();
    setActivePhotoIndex(function (i) {
      return i === 0 ? activeRoom.images.length - 1 : i - 1;
    });
  }

  function nextPhoto(e) {
    e.stopPropagation();
    setActivePhotoIndex(function (i) {
      return i === activeRoom.images.length - 1 ? 0 : i + 1;
    });
  }

  if (loading) return <div className="not-found container"><p>Loading...</p></div>;
  if (!property) return <div className="not-found container"><h2>Property not found</h2></div>;

  var rooms = property.rooms && property.rooms.length > 0 ? property.rooms : [];

  return (
    <div className="property-page">

      {/* HERO */}
      <div className="prop-hero">
        {property.heroVideo ? (
          <video className="prop-hero-video" src={property.heroVideo} autoPlay muted loop playsInline />
        ) : (
          <div className="prop-hero-bg" style={{ backgroundImage: "url(" + property.heroImage + ")" }} />
        )}
        <div className="prop-hero-overlay" />
        <div className="prop-hero-content">
          <div className="eyebrow"><div className="eline"></div><span className="etxt">{property.type}</span></div>
          <h1>{property.name}</h1>
          <p>{property.location}</p>
        </div>
      </div>

      {/* MAIN */}
      <div className="prop-main container">
        <div className="prop-detail">
          <div className="prop-info">
            <div className="prop-rating-row">
              <span className="star-rating">&#9733; {property.rating}</span>
              <span className="review-count">({property.reviewCount} reviews)</span>
              <span className="price-from">from {property.priceFrom} EUR/night</span>
            </div>
            <h2>{property.tagline}</h2>
            <p className="prop-desc">{property.description}</p>
            <div className="prop-amenities">
              <h3>Amenities</h3>
              <div className="amenities-grid">
                {(property.amenities || []).map(function (a) {
                  return <span key={a} className="amenity-tag">{a}</span>;
                })}
              </div>
            </div>
          </div>

          <div className="prop-booking-box">
            <div className="booking-price-row">
              <span className="booking-from">from</span>
              <span className="booking-price">{property.priceFrom} EUR</span>
              <span className="booking-per">/night</span>
            </div>
            <div className="booking-rating">&#9733; {property.rating} &nbsp; ({property.reviewCount} reviews)</div>
            <a href={property.beds24Url} target="_blank" rel="noreferrer" className="booking-btn">Check Availability</a>
            <p className="booking-note">Secure booking via Beds24</p>
          </div>
        </div>

        {/* ROOMS GALLERY */}
        {rooms.length > 0 && (
          <div className="prop-gallery">
            {rooms.map(function (room, i) {
              var coverImg = (room.images && room.images[0]) || null;
              return (
                <div key={i} className="gallery-item" onClick={function () { openRoom(room); }}>
                  {coverImg
                    ? <img src={coverImg} alt={room.label || property.name} className="gallery-img" />
                    : <div className="gallery-img-placeholder" />
                  }
                  {room.label && <div className="gallery-label">{room.label}</div>}
                  <div className="gallery-hover-hint">View Room</div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ROOM MODAL */}
      {activeRoom && (
        <div className="room-modal-overlay" onClick={closeRoom}>
          <div className="room-modal" onClick={function (e) { e.stopPropagation(); }}>
            <button className="room-modal-close" onClick={closeRoom}>×</button>

            {/* Photo area */}
            <div className="room-modal-img-wrap">
              {activeRoom.images && activeRoom.images.length > 0 ? (
                <>
                  <img
                    src={activeRoom.images[activePhotoIndex]}
                    alt={activeRoom.label || "Room"}
                    className="room-modal-img"
                  />
                  {activeRoom.images.length > 1 && (
                    <>
                      <button className="room-modal-nav room-modal-prev" onClick={prevPhoto}>‹</button>
                      <button className="room-modal-nav room-modal-next" onClick={nextPhoto}>›</button>
                      <div className="room-modal-dots">
                        {activeRoom.images.map(function (_, idx) {
                          return (
                            <button
                              key={idx}
                              className={"room-modal-dot" + (idx === activePhotoIndex ? " active" : "")}
                              onClick={function (e) { e.stopPropagation(); setActivePhotoIndex(idx); }}
                            />
                          );
                        })}
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div className="gallery-img-placeholder" />
              )}
            </div>

            {/* Body */}
            <div className="room-modal-body">
              {activeRoom.label && <h2 className="room-modal-title">{activeRoom.label}</h2>}
              {activeRoom.description && <p className="room-modal-desc">{activeRoom.description}</p>}
              <a href={property.beds24Url} target="_blank" rel="noreferrer" className="booking-btn room-modal-btn">
                Check Availability
              </a>
              <p className="booking-note room-modal-note">Secure booking via Beds24</p>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}